import { useParams } from "react-router-dom";
import VideoFrame from "../../components/media/VideoFrame";
import QueryBoundary from "../../components/ui/QueryBoundary";
import useApiQuery from "../../hooks/useApiQuery";
import endpoints from "../../api/endpoints";

// The backend keys lives by slug; the original hardcoded "salam" and this
// keeps that default while allowing a real slug through the route.
const DEFAULT_LIVE_SLUG = process.env.REACT_APP_LIVE_SLUG || "salam";

const LivePage = () => {
  const { id } = useParams();
  const query = useApiQuery(endpoints.live(DEFAULT_LIVE_SLUG));

  return (
    <QueryBoundary {...query}>
      {(live) => (
        <div className="relative w-full pb-[56.25%]">
          <div className="absolute left-0 top-0 h-full w-full">
            <VideoFrame src={live.embed} title={`live-${id}`} />
          </div>
        </div>
      )}
    </QueryBoundary>
  );
};

export default LivePage;
